import { createAction, handleActions } from 'redux-actions';
import { Map } from 'immutable';
export const actions = {
    REQUEST: createAction('GLOBAL/ORGANIZATION_ACTIVE_USERS/REQUEST'),
    SUCCESS: createAction('GLOBAL/ORGANIZATION_ACTIVE_USERS/SUCCESS'),
    ERROR: createAction('GLOBAL/ORGANIZATION_ACTIVE_USERS/ERROR'),
};
export const initialState = Map({
    data: null,
    isProcessing: null,
    selectAll: false,
    error: null,
    loaded: false,
    totalElements: null,
});
const reducer = handleActions({
    [actions.REQUEST]: (state) => state.merge({
        isProcessing: true,
        error: false,
    }),
    [actions.SUCCESS]: (state, action) => {
        return state.merge({
            data: action.payload.content,
            isProcessing: false,
            error: false,
            loaded: true,
            totalElements: action.payload.totalElements,
        });
    },
    [actions.ERROR]: (state) => state.merge({
        isProcessing: false,
        error: true,
        loaded: true,
    }),
}, initialState);
export default reducer;
export const organizationActiveUsersSelector = (state) => state.organizationActiveUsers.get('data');
export const isProcessingSelector = (state) => state.organizationActiveUsers.get('isProcessing');
export const isErrorSelector = (state) => state.organizationActiveUsers.get('error');
